import { styled } from '@linaria/react';

export const SeeMoreOddsNoticeHeader = styled.h4`
  font-family: var(--ogm-font-family-2);
  font-size: 18px;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
`;

export const SeeMoreOddsNoticeBody = styled.p`
  font-family: var(--ogm-font-family-2);
  font-size: 15px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
`;

export const SeeMoreOddsNoticeWrapper = styled.div`
  padding: 10px 15px 10px 16px;
  display: grid;
  grid-gap: 10px;
`;

export const SeeMoreOddsNoticeButton = styled.div`
  background-color: #4285f4;
  border-radius: 3px;
  border: solid 1px var(--oc-text-white);
  cursor: pointer;
  font-weight: 800;
  height: 32px;
  padding: 5px 15px;
  pointer-events: visible !important;
  z-index: var(--cxy-z-index-see-more-odds);
  font-size: 16px;
  width: fit-content;
`;
